










import { Vue, Component } from 'vue-property-decorator';
import { App, AppInfo } from '@capacitor/app';

@Component
export default class EnvironmentBanner extends Vue {
  appInfo: AppInfo | null = null;
  environment = process.env.ENVIRONMENT?.toString().toUpperCase();

  get isProd(): boolean | undefined {
    return process.env.ENVIRONMENT?.includes('prod');
  }

  get isMobile(): boolean {
    return this.$tStore.state.setting.platform !== 'web';
  }

  async mounted() {
    this.appInfo =this.$q.platform.is.capacitor ? await App.getInfo() : null;
  }

  get appVersion(): string {
    let version = '';
    if (this.appInfo) {
      version = this.appInfo.version;
      if (version.includes('-')) {
        version = version.split('-')[0];
      }
    }
    return version;
  }

  get appBuild(): string {
    return this.appInfo ? this.appInfo.build : '';
  }

  get isNative() {
    return this.$tStore.state.setting.platform != 'web';
  }
}
